import { render, staticRenderFns } from "./Outro.vue?vue&type=template&id=0db93bf1&scoped=true"
import script from "./Outro.vue?vue&type=script&lang=js"
export * from "./Outro.vue?vue&type=script&lang=js"
import style0 from "./Outro.vue?vue&type=style&index=0&id=0db93bf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db93bf1",
  null
  
)

export default component.exports